import axios from '../api/axiosInstance';

export const fetchShops = (params) => {
  return axios.get('/shops', { params });
};

export const createShop = (data) => {
  return axios.post('/shops', data);
};

export const updateShop = (id, data) => {
  return axios.put(`/shops/${id}`, data);
};

export const updateShopStatus = (id, status) => {
  return axios.patch(`/shops/${id}/status`, { status });
};

export const deleteShop = (id) => {
  return axios.delete(`/shops/${id}`);
};

export const fetchCategories = () => {
  return axios.get('/shop-categories');
};

// Shop images
export const fetchShopImages = (shopId) => {
  return axios.get(`/shops/${shopId}/images`);
};

export const createShopImage = (shopId, data) => {
  const formData = new FormData();
  formData.append('image', data.file);
  formData.append('type', data.type);
  formData.append('isPrimary', data.isPrimary);
  return axios.post(`/shops/${shopId}/images`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const updateShopImage = (shopId, imageId, data) => {
  return axios.patch(`/shops/${shopId}/images/${imageId}`, data);
};

export const deleteShopImage = (shopId, imageId) => {
  return axios.delete(`/shops/${shopId}/images/${imageId}`);
};

// Shop timings
export const fetchShopTimings = (shopId) => {
  return axios.get(`/shops/${shopId}/timings`);
};

export const createShopTiming = (shopId, data) => {
  return axios.post(`/shops/${shopId}/timings`, data);
};

export const updateShopTiming = (shopId, timingId, data) => {
  return axios.patch(`/shops/${shopId}/timings/${timingId}`, data);
};

export const deleteShopTiming = (shopId, timingId) => {
  return axios.delete(`/shops/${shopId}/timings/${timingId}`);
};
